import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLoginStep4 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgLoginStep4);
const Memo = memo(ForwardRef);
export default Memo;
